module.exports = __webpack_public_path__ + "img/cloud.e5950142.png";